/**
 * SPATIAL NAVIGATION MANAGER
 * Enables navigation using Arrow Keys (Up/Down/Left/Right)
 * Essential for kids who intuitively use arrows instead of Tab.
 */

const SpatialNavigation = {
    init() {
        console.log('🎮 SpatialNavigation Initialized');
        this.setupGlobalListener();
    },

    setupGlobalListener() {
        document.addEventListener('keydown', (e) => {
            // Only react to arrow keys
            if (!['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key)) return;

            // Get current focused element
            const current = document.activeElement;

            // Ignore if focus is on body, inputs, or textareas
            if (!current || current === document.body || ['INPUT', 'TEXTAREA'].includes(current.tagName)) return;

            // Identify the container (grid, list, menu)
            // We look for a parent with 'data-spatial-nav' or specific classes like 'store-grid'
            const container = current.closest('[data-spatial-nav], .store-grid, .wizard-steps-indicator, .modal-content, .profiles-grid, .option-grid, .context-grid, .language-list, .step-indicator-container, .container, .screen');

            if (container) {
                e.preventDefault(); // Prevent scrolling
                this.navigate(e.key, current, container);
            }
        });
    },

    navigate(direction, currentEl, container) {
        // Find all focusable siblings in the container
        const focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
        const allItems = Array.from(container.querySelectorAll(focusableSelector))
            .filter(el => !el.disabled && el.offsetParent !== null); // Visible and enabled only

        if (allItems.length <= 1) return;

        // Calculate geometry
        const currentRect = currentEl.getBoundingClientRect();
        const currentCenter = {
            x: currentRect.left + currentRect.width / 2,
            y: currentRect.top + currentRect.height / 2
        };

        let bestCandidate = null;
        let minDistance = Infinity;

        allItems.forEach(candidate => {
            if (candidate === currentEl) return;

            const rect = candidate.getBoundingClientRect();
            const center = {
                x: rect.left + rect.width / 2,
                y: rect.top + rect.height / 2
            };

            // Filter by direction
            let isValidDirection = false;
            switch (direction) {
                case 'ArrowRight': isValidDirection = center.x > currentCenter.x; break;
                case 'ArrowLeft': isValidDirection = center.x < currentCenter.x; break;
                case 'ArrowDown': isValidDirection = center.y > currentCenter.y; break;
                case 'ArrowUp': isValidDirection = center.y < currentCenter.y; break;
            }

            if (isValidDirection) {
                // Euclidean distance
                const dist = Math.hypot(center.x - currentCenter.x, center.y - currentCenter.y);

                // Penalize misalignment to favor straight lines
                // (e.g. if moving Down, we prefer items directly below, not diagonal)
                let alignmentPenalty = 0;
                if (direction === 'ArrowUp' || direction === 'ArrowDown') {
                    alignmentPenalty = Math.abs(center.x - currentCenter.x) * 3.5;
                } else {
                    alignmentPenalty = Math.abs(center.y - currentCenter.y) * 3.5;
                }

                const totalScore = dist + alignmentPenalty;

                if (totalScore < minDistance) {
                    minDistance = totalScore;
                    bestCandidate = candidate;
                }
            }
        });

        if (bestCandidate) {
            bestCandidate.focus();
            // Optional sound effect
            if (window.SoundService && window.SoundService.playHover) {
                window.SoundService.playHover();
            }
        }
    }
};

window.SpatialNavigation = SpatialNavigation;

// Auto-init
document.addEventListener('DOMContentLoaded', () => {
    window.SpatialNavigation.init();
});
